import { curry, type PlatformEvent } from 'lib/util'
import { setData } from 'lib/sequence/model/api/set'
import { showBlockingDialog } from 'app/_shared/events/dialog'

/**
 * Shows a dialog asking the user to first register the machine.
 *
 * @param module    current module
 * @param component event source
 */
const showDeviceNotRegisteredDialog = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
) => await showBlockingDialog(module, component, {
  title: {
    ns: 'apmGo',
    key: 'dialog.deviceNotRegistered.title',
    defaultValue: 'Machine not registered',
  },
  text: {
    ns: 'apmGo',
    key: 'dialog.deviceNotRegistered.text',
    defaultValue: 'Please, register the machine and try again.',
  },
  cancel: false,
})

/**
 * Sets the event detail's item as the item in the current measurement model.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const setProject = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const { item: itemData } = event.detail
  const [organisationData] = itemData.refs?.installedAt || []

  if (!organisationData) {
    await showDeviceNotRegisteredDialog(module, component)
    throw new Error('Device not registered')
  }

  setData(measurement, {
    project: itemData.value.serial,
    customer: organisationData.value.name,
    item: [itemData.key],
    organisation: [organisationData.key]
  }, { updateCache: true })
}

export default curry(setProject)
